<!-- *** NEW DESIGN *** -->

<div fxLayout="row wrap" fxLayoutAlign="space-between">
	<div
		 mat-dialog-title 
		 class="main-title">
		{{ "faq.mainTitle" | translate }}
	</div>

	<mat-form-field appearance="outline">
		<mat-label>{{ "faq.search" | translate }}</mat-label>
		<mat-select [(ngModel)]="selectedInsurer">
			<mat-option>
				<ngx-mat-select-search
					(ngModelChange)="onSearch($event)"
					placeholderLabel="{{ 'faq.searchPlaceholder' | translate }}"
					noEntriesFoundLabel="No matching partner found"
					ngModel
              		ngDefaultControl
				>
				</ngx-mat-select-search>
			</mat-option>
			<mat-option>{{ "faq.searchSelectionGeneral" | translate }}</mat-option>
			<mat-optgroup [label]="'faq.searchSelectionGroupInsurers' | translate">
				<mat-option
					*ngFor="let insurer of filteredInsurerList"
					[value]="insurer.id"
				>
					{{ insurer.name }}
				</mat-option>
			</mat-optgroup>
			
		
		</mat-select>
	</mat-form-field>
</div>

<mat-divider></mat-divider>

<mat-dialog-content>
	<container-element [ngSwitch]="selectedInsurer">
		<div *ngSwitchDefault>
			<ng-container *ngTemplateOutlet="ps"></ng-container>
		</div>
		
		<div *ngSwitchCase="'zurich'">
			<ng-container *ngTemplateOutlet="zurich"></ng-container>
		</div>
	</container-element>
	
</mat-dialog-content>

<!-- Templates -->
<ng-template #ps>
	<div>
		<h4 class="section-title">{{ "faq.title1" | translate }}</h4>
		<mat-accordion>
			<mat-expansion-panel
				*ngFor="let question of faqQuestions.general"
				(opened)="panelOpenState = true"
				(closed)="panelOpenState = false"
			>
				<mat-expansion-panel-header>
					<mat-panel-title>
						{{ question.question }}
					</mat-panel-title>
				</mat-expansion-panel-header>
				<p
					class="answer-text"
					[innerHTML]="getSanitizedAnswer(question.answer)"
				>
					{{ question.answer }}
				</p>
			</mat-expansion-panel>
		</mat-accordion>
	</div>

	<div>
		<h4 class="section-title">{{ "faq.title2" | translate }}</h4>
		<mat-accordion>
			<mat-expansion-panel
				*ngFor="let question of faqQuestions.renewal"
				(opened)="panelOpenState = true"
				(closed)="panelOpenState = false"
			>
				<mat-expansion-panel-header>
					<mat-panel-title>
						{{ question.question }}
					</mat-panel-title>
				</mat-expansion-panel-header>
				<p
					class="answer-text"
					[innerHTML]="getSanitizedAnswer(question.answer)"
				>
					{{ question.answer }}
				</p>
			</mat-expansion-panel>
		</mat-accordion>
	</div>

	<div>
		<h4 class="section-title">{{ "faq.title3" | translate }}</h4>
		<mat-accordion>
			<mat-expansion-panel
				*ngFor="let question of faqQuestions.claims"
				(opened)="panelOpenState = true"
				(closed)="panelOpenState = false"
			>
				<mat-expansion-panel-header>
					<mat-panel-title>
						{{ question.question }}
					</mat-panel-title>
				</mat-expansion-panel-header>
				<p
					class="answer-text"
					[innerHTML]="getSanitizedAnswer(question.answer)"
				>
					{{ question.answer }}
				</p>
			</mat-expansion-panel>
		</mat-accordion>
	</div>

	<div>
		<h4 class="section-title">{{ "faq.title4" | translate }}</h4>
		<mat-accordion>
			<mat-expansion-panel
				*ngFor="let question of faqQuestions.roadtax"
				(opened)="panelOpenState = true"
				(closed)="panelOpenState = false"
			>
				<mat-expansion-panel-header>
					<mat-panel-title>
						{{ question.question }}
					</mat-panel-title>
				</mat-expansion-panel-header>
				<p
					class="answer-text"
					[innerHTML]="getSanitizedAnswer(question.answer)"
				>
					{{ question.answer }}
				</p>
			</mat-expansion-panel>
		</mat-accordion>
	</div>
</ng-template>

<ng-template #zurich>
	<div>
		<h4 class="section-title">{{ "faq.title1" | translate }}</h4>
		<mat-accordion>
			<mat-expansion-panel
				(opened)="panelOpenState = true"
				(closed)="panelOpenState = false"
				[expanded]="true"
			>
				<mat-expansion-panel-header>
					<mat-panel-title>
						{{ "faq.zurichRefundStatementTitle" | translate }}
					</mat-panel-title>
				</mat-expansion-panel-header>
				<p
					class="answer-text"
					[innerHTML]="'faq.zurichRefundStatement' | translate"
				>
				</p>

				<table 
					mat-table 
					[dataSource]="zurichFAQTableData"
				>
					<ng-container matColumnDef="period">
						<th mat-header-cell *matHeaderCellDef>{{ 'faq.zurichFAQTableColumn1' | translate }}</th>
						<td mat-cell *matCellDef="let element">{{element.period}}</td>
					</ng-container>

					<ng-container matColumnDef="refundPercentage">
						<th mat-header-cell *matHeaderCellDef>{{ 'faq.zurichFAQTableColumn2' | translate }}</th>
						<td mat-cell *matCellDef="let element">{{element.refundPercentage}}</td>
					</ng-container>					
					
					<tr mat-header-row *matHeaderRowDef="zurichFAQTableColumns"></tr>
					<tr mat-row *matRowDef="let row; columns: zurichFAQTableColumns"></tr>
				</table>
			</mat-expansion-panel>
		</mat-accordion>

		<mat-accordion>
			<mat-expansion-panel
				(opened)="panelOpenState = true"
				(closed)="panelOpenState = false"
				[expanded]="true"
				style="margin-top: 16px;"
			>
				<mat-expansion-panel-header>
					<mat-panel-title>
						{{ "faq.zurichContactTitle" | translate }}
					</mat-panel-title>
				</mat-expansion-panel-header>

				<p class="answer-text">
					{{ 'faq.zurichContactDesc' | translate }}
				</p>

				<br />

				<div class="zurich-info-container">
					<p class="answer-text">
						Zurich General Takaful Malaysia Berhad / Zurich General Insurance Malaysia Berhad
					</p>

					<br />

					<p>Level 23A, Mercu 3. No.3, Jalan Bangsar, KL Eco City, 59200 Kuala Lumpur</p>

					<br />

					<div fxLayout="row" fxLayoutAlign="start center">
						<img src="https://storage.googleapis.com/ps-asset/ps_icons/call.svg" />
						<span>1-300-888-622 (Call Centre) / 603-2019 6000 (Tel)</span>
					</div>

					<br />

					<p fxLayout="row" fxLayoutAlign="start center">
						<img src="https://storage.googleapis.com/ps-asset/ps_icons/email.svg" />
						<span class="underline-email">callcentre@zurich.com</span>
					</p>
				</div>
			</mat-expansion-panel>
		</mat-accordion>
	</div>
</ng-template>